import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import InfoCard from '../../components/InfoCard';
import CallToAction from '../../components/CallToAction';
import '../Home.css';

import bannerImage from '../../assets/images/banner.jpg';
import ai1 from '../../assets/images/ai1.jpg';
import ai2 from '../../assets/images/ai2.jpg';
import ai3 from '../../assets/images/ai3.jpg';

const HomeEN = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ProgenX - Software & IT Solutions | AI, IoT, Smart Reporting 2026</title>
        <meta name="description" content="ProgenX is an innovative technology company offering software development, artificial intelligence, IoT and smart reporting solutions. Your trusted partner for digital transformation projects in education, healthcare and industry." />
        <meta name="keywords" content="progenx, software development, artificial intelligence, IoT, smart reporting, enterprise software, mobile app, web development, IT solutions, digital transformation" />
        <meta property="og:title" content="ProgenX | Software & IT Solutions" />
        <meta property="og:description" content="Shaping your digital future with software, AI, IoT and smart reporting solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/en" />
        <meta property="og:image" content="https://progenx.com.tr/banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX | Software & IT Solutions" />
        <meta name="twitter:description" content="Software, AI, IoT and smart reporting solutions." />
        <link rel="canonical" href="https://progenx.com.tr/en" />
        <link rel="alternate" hreflang="tr" href="https://progenx.com.tr" />
        <link rel="alternate" hreflang="en" href="https://progenx.com.tr/en" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX",
            "url": "https://progenx.com.tr",
            "logo": "https://progenx.com.tr/logo.png",
            "description": "Technology company offering software development, AI, IoT and smart reporting solutions",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "addressCountry": "TR"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-538-686-54-16",
              "contactType": "customer service",
              "email": "info@progenx.com.tr"
            },
            "sameAs": [
              "https://tr.linkedin.com/company/progenx-academy",
              "https://www.instagram.com/progenxacademy/"
            ]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="PROGENX" 
        subtitle={'"The best way to predict the future is to create it." -Peter Drucker & Abraham Lincoln'}
        buttonText="About Us" 
        buttonLink="/en/about" 
        backgroundImage={bannerImage}
        isHomePage={true}
      />
      
      <section className="home-intro">
        <div className="container">
          <h2 className="section-title">Shape Your Future with Software & Technology Solutions</h2>
          <p className="intro-text">
            At ProgenX, we develop software solutions across a wide spectrum from education to industry. 
            With AI-powered smart systems, IoT integrations and enterprise software projects, 
            we are a trusted technology partner in businesses' digital transformation journeys. 
            We optimize your workflows and transform your data into value with our innovative solutions.
          </p>
          
          <div className="card-row">
            <div className="card-column">
              <InfoCard 
                title="Custom Software Solutions" 
                description="We develop custom web, mobile and desktop applications for your business. We digitize your workflows with scalable and reliable software projects tailored to your enterprise needs, delivering top performance with modern technologies."
                image={ai1}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Data Science & Artificial Intelligence" 
                description="We extract meaningful insights from large datasets and strengthen business decision-making with AI and machine learning models. We transform your data into value with smart reporting and forecasting systems."
                image={ai2}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="IoT & Smart Systems" 
                description="We connect your devices with Internet of Things (IoT) solutions, automate your industrial processes with embedded systems and smart sensor integrations. We deliver operational efficiency through real-time data collection and analysis."
                image={ai3}
              />
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="We're With You on Your Digital Transformation Journey"
        subtitle="Let's discuss your project and create the right solution together."
        buttonText="Contact Us" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default HomeEN;
